import { Creep } from '../creep/creep';

const _defaultRequiresCreepLevel: number[] = [0, 2, 7, 14, 22];

export class Skill {
  private _creepRef: Creep;

  constructor(
    public name: string,
    public desk: string,
    public level: number = 0,
    public requiresLevel: number[] = _defaultRequiresCreepLevel
  ) {
  }

  decLevel() {
    this.level--;
    this._creepRef.decLevel();
  }

  incLevel() {
    if (!this._creepRef) {
      throw Error('Not set creepRef');
    }

    if (!this.upgradeAvailable() || !this._creepRef.upgradeAvailable()) {
      throw Error('Upgrade not available');
    }

    this.level++;
    this._creepRef.incLevel();
  }

  get creepRef() {
    return this._creepRef;
  }

  set creepRef(ref) {
    this._creepRef = ref;
  }

  requiredCreepLevel(): number {
    return this.requiresLevel[this.level];
  }

  upgradeAvailable(): boolean {
    return this._creepRef.level >= this.requiredCreepLevel();
  }
}



// WEBPACK FOOTER //
// /home/runner/work/power-planner/power-planner/src/app/creep-skill/index.ts